// extracted by mini-css-extract-plugin
export default {"wrapper":"FreemiumEndinginfo__wrapper--2xyri","content":"FreemiumEndinginfo__content--6gOqW"};